import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { CommonService } from 'src/app/core/services/common.service';
import { EnduserService } from 'src/app/core/services/enduser.service';
import { ProductService } from 'src/app/core/services/product.service';
import { StorebuilderService } from 'src/app/core/services/storebuilder.service';
import { UserService } from 'src/app/core/services/user.service';
import { UserLoginComponent } from '../../../user-login/user-login.component';
import { MatDialog } from '@angular/material/dialog';
import { environment } from 'src/environments/environment';
import { StoreService } from 'src/app/core/services/store.service';


@Component({
  selector: 'app-third-form',
  templateUrl: './third-form.component.html',
  styleUrls: ['./third-form.component.scss']
})
export class ThirdFormComponent {
  @Input() storeDetailForm: UntypedFormGroup;
  @Input() shippingSelect: any;
  @Output() submit = new EventEmitter<void>();
  @Input() userSelectedOrganization: any

  user: any;
  states: any;
  currentUser: any;
  isBulkPickup: boolean;

  isNewUser
  isLaunchAction

  markets: any;
  agreeToTerms: boolean = false;
  teamStore: any;
  storeRequestForm: UntypedFormGroup;
  storeId: any;
  organizationArray: any;
  wpUrl = environment.wpUrl; 
  
  constructor(private endUserService: EnduserService, private userService: UserService, private commonService: CommonService,
    private router: Router, private storeService: StoreService, private storeBuilderService: StorebuilderService, public dialog: MatDialog,) { }

  ngOnInit(): void{
    // if (this.storeDetailForm.value.id == 0 && this.storeDetailForm.value.emailId) {
    //   this.checkUserByEmail(this.storeDetailForm.value.emailId);
    // }

    this.isNewUser = !this.storeDetailForm.value.isVerifiedUser;
    this.isLaunchAction = this.storeDetailForm.value.status == 'launch' ? true : false
    this.storeId = this.storeDetailForm.value.id;
    this.getStates()
    if (this.isLaunchAction) {

      this.setRequired('name', true);
      this.setRequired('shippingPreference', true);
      this.setRequired('shipToCity', true);
      this.setRequired('shipToState', true);
      this.setRequired('shipToZipCode', true);
      this.setRequired('shipToAddress', false);
      this.setRequired('shipToAddress1', false);
      // this.setRequired('fullName', false);
      // this.setRequired('fundRaisingClaimPreference', true);

    } else {
      // this.setRequired('fullName', true); 
      this.setRequired('name', false);
      this.setRequired('shippingPreference', false);
      this.setRequired('shipToCity', false);
      this.setRequired('shipToState', false);
      this.setRequired('shipToZipCode', false);
      this.setRequired('shipToAddress', false);
      this.setRequired('shipToAddress1', false);
      // this.setRequired('fundRaisingClaimPreference', false); 
    }
    this.setRequired('firstName', true);
    this.setRequired('lastName', true);
    this.setRequired('marketId', true);
    this.setRequired('phoneNumber', true);
    this.setRequired('userStateRegion', true);

    this.setRequired('agreeToTerms', true);


    this.storeDetailForm?.get('shippingPreference')?.valueChanges.subscribe((selectedValue: string) => {
      this.onShippingMethodChange(selectedValue);
    });


    this.getMarkets()
    console.log(this.markets)
    if (this.storeId) {
      this.getTeamStore(Number(this.storeId))
    }


    //this.commonService.postHeightToParent("medium")
    // this.commonService.postHeightToParent("high")
    // this.commonService.postHeightToParent("ultra")
    this.commonService.postIframeHeight();
    }

  ngAfterViewInit() {
    this.commonService.postIframeHeight();
  }
  setRequired(controlName: string, required: boolean) {
    const control = this.storeDetailForm.get(controlName);
    if (!control) return;

    if (required) {
      if (controlName === 'agreeToTerms') {
        control.setValidators(Validators.requiredTrue);
      } else {
        control.setValidators(Validators.required);
      }
    } else {
      control.clearValidators();
    }
    control.updateValueAndValidity();
  }
  


  getTeamStore(teamStoreId) {
    this.commonService.toggleLoading(true)
    this.storeBuilderService.getTeamStore(teamStoreId).subscribe(response => {
      this.commonService.toggleLoading(false)
      this.teamStore = response.data;

      this.storeDetailForm.patchValue({
        id: this.teamStore.id,
        stage: this.teamStore.stage,
        isUserExists: true,
        name: this.teamStore.name,
        firstName: (this.teamStore.firstName || ''),
        lastName: (this.teamStore.lastName || ''),
        emailId: this.teamStore.emailId,
        phoneNumber: this.teamStore.phoneNumber,
        organizationName: this.teamStore.organizationName,
        shippingPreference: this.teamStore.shippingPreference.toString(),
        marketId: this.teamStore.marketId,
        shipToState: this.teamStore.shipToState,
        agreeToTerms: this.teamStore?.agreeToTerms ?? '',
        action: 'complete'
      });

      this.onShippingMethodChange(this.teamStore.shippingPreference.toString());
      //this.getOrganisations()

      this.markFormTouched();

    },
      error => {
        this.commonService.toggleLoading(false)
        this.commonService.openErrorSnackBar(error.message, "");
      });
  }

  getOrganisations() {
    if (this.teamStore.emailId) {
      this.endUserService.getAllOrganizations().subscribe(response => {
        this.organizationArray = response.data
      })
    }
  }

  getMarkets() {

    this.storeService.getAllMarkets().subscribe(
      (response: any) => {
        this.markets = response.data;
      },
      (error) => {
      }
    );

  }

  checkUserByEmail(email: string): void {
    this.endUserService.getUserInfoUsingEmaiId(email).subscribe({
      next: (response) => {
        this.user = response?.data;
        this.storeDetailForm.patchValue({
          firstName: this.user?.firstName,
          lastName: this.user?.lastName,
          phoneNumber: this.user?.phoneNumber
        });
        if (this.user?.id) {
          this.getUser(this.user.id)
        }

      },
      error: () => { }
    });
  }

  getStates(): void {
    this.endUserService.getAllStates().subscribe(response => {
      if (response.data != null) {
        this.states = response.data;
      }
    });
  }

  // 👉 Call this from the parent
  public markFormTouched(): void {
    Object.values(this.storeDetailForm.controls).forEach(control => {
      control.markAsTouched();
      control.updateValueAndValidity();
    });
  }

  getUser(userId) {
    this.userService.getUserProfileDetails(userId).subscribe(response => {
      this.currentUser = response.data;
      this.storeDetailForm.patchValue({
        isVerifiedUser: this.currentUser?.emailConfirmed,
      });
    },
      error => {
        this.currentUser = {}
        console.log("User not available")
      });
  }

  onShippingMethodChange(value): void {
    const selectedValue = value;

    this.isBulkPickup = selectedValue === "3"; 
    if (selectedValue === "3") {
      this.storeDetailForm.patchValue({
        shipToAddress: "Ares Sportswear",
        shipToAddress1: "3700 Lacon Road Suite A",
        shipToCity: "Hilliard",
        shipToState: 35,
        shipToZipCode: 43026,
      });
    } else if (selectedValue === "2") {
      if (this.userSelectedOrganization) {
        this.storeDetailForm.patchValue({
          shipToAddress: this.userSelectedOrganization.address,
          shipToAddress1: this.userSelectedOrganization.address1,
          shipToCity: this.userSelectedOrganization.city,
          shipToState: Number(this.userSelectedOrganization.state),
          shipToZipCode: this.userSelectedOrganization.zip,
        });
       

      }
    }

    if (selectedValue !== "3") {
      this.isBulkPickup = false;
    }
  }

  submitForm(): void { 
    if (this.storeDetailForm.valid) {
      this.submit.emit();
    }else{
      this.commonService.openWarningSnackBar('Please fill mandatory fields','')
    } 
  }
  termsChanged() {
    this.storeDetailForm.patchValue({ agreeToTerms: this.storeDetailForm.value.agreeToTerms })
  }

  goToMyStore(){
    const isLoggedInUser = JSON.parse(localStorage.getItem('user'));
    if (isLoggedInUser && isLoggedInUser.roles[0].name == "ENDUSER") {
      this.router.navigateByUrl('enduser/useraccount/my-stores');
    } else{
      const data = {
        isFromSelectTeam: true,
        email: this.storeDetailForm.value.emailId
      }
      this.openUserLogin(data)
    }
    this.commonService.postIframeHeight();
  }
  openUserLogin(data): void {
    this.dialog.open(UserLoginComponent, {
      data: data,
      disableClose: true,
      width: '500px',
      height: 'auto',
      maxHeight: '100vh',
      panelClass: 'full-height-dialog'
    });
  }
  



}
